import { HTMLProps, PropsWithChildren } from 'react';

import { TextVariants } from './Text.enums';

export enum TEXT_CONST {
  TEST_ID = 'text',
}

type SpaceVariations = 0 | 2 | 4 | 6 | 8 | 10 | 12 | 14 | 16 | 18 | 20 | 22;

type Spaces = `sp-${SpaceVariations}`;

type Text = Omit<HTMLProps<HTMLDivElement>, 'as'> & {
  color?: string;
  /**
   * Variant of the text that all characters are uppercase. Default: false
   */
  overline?: boolean;
  textAlign?: 'center' | 'left' | 'right';
  /**
   * Variant of the text based on line-height or font-size. Default: 'body-medium-standard'.
   */
  variant?: `${TextVariants}`;
  marginBottom?: Spaces;
};

export type TextProps = PropsWithChildren<Text>;
